export type ProjectViewEventType = 'loaded' | 'unityEvent'

export type ResourceType = 'Building' | 'LocalGrid' | 'EnergyBus'

export type ResourceClickEventData = {
  type: 'ResourceClick'
  resourceType: ResourceType
  resourceId: string
}

export type ResourceHoverEventData = {
  type: 'ResourceHover'
  resourceType: ResourceType
  resourceId: string
}

export type ResourceHoverExitEventData = {
  type: 'ResourceHoverExit'
  resourceType: ResourceType
  resourceId: string
}

export type ChangeCursorEvent = {
  type: 'ChangeCursor'
  cursor: string
}

export type ProjectViewEventData =
  | ResourceClickEventData
  | ResourceHoverEventData
  | ResourceHoverExitEventData
  | ChangeCursorEvent

export class ProjectViewEvent extends Event {
  public constructor(
    type: ProjectViewEventType,
    public readonly data?: ProjectViewEventData,
  ) {
    super(type)
  }
}
